export function isInternalLink(path){
    const isSameOrigin = path && (path.startsWith(window.location.origin) || path.startsWith('/'));
    return isSameOrigin;
}